import { componentSizeLabel } from './component-size-label';

export type CombinationConfigLine = {
  label: string;
  text: string;
};

const GENERIC_MANUFACTURER = 'Generic';

const POSITION_LINES = [
  {
    label: 'Outdoor',
    manufacturer: 'OutdoorManufacturer',
    model: 'OutdoorModelNumber'
  },
  {
    label: 'Indoor',
    manufacturer: 'IndoorManufacturer',
    model: 'IndoorModelNumber'
  },
  {
    label: 'Blower',
    manufacturer: 'BlowerManufacturer',
    model: 'BlowerModelNumber'
  }
] as const;

export function combinationConfigLines(
  combination: Record<string, unknown>,
  modelSpecs: Record<string, Record<string, unknown>> = {}
): CombinationConfigLine[] {
  return POSITION_LINES.flatMap((position) => {
    const manufacturer = combination[position.manufacturer];
    const model = combination[position.model];
    const modelText = [manufacturer, model].filter(Boolean).join(' ');
    if (!modelText) return [];
    const text =
      manufacturer === GENERIC_MANUFACTURER
        ? `Customer's unit (${modelText})`
        : modelText;
    const spec =
      typeof manufacturer === 'string' && typeof model === 'string'
        ? modelSpecs[`${manufacturer}|${model}`]
        : undefined;
    const size = componentSizeLabel(position.label, spec, combination);
    return [{ label: position.label, text: size ? `${size} ${text}` : text }];
  });
}
